import { useTranslation } from "react-i18next";

const onlineTransactionStatusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "OPEN",
      title: t("options.transStatus.open"),
      value: "OPEN",
    },
    {
      key: "SUCCESS",
      title: t("options.transStatus.success"),
      value: "SUCCESS",
    },
    {
      key: "SETTLED",
      title: t("options.transStatus.settled"),
      value: "SETTLED",
    },
    {
      key: "VOIDED",
      title: t("options.transStatus.voided"),
      value: "VOIDED",
    },
    {
      key: "DECLINED",
      title: t("options.transStatus.declined"),
      value: "DECLINED",
    },
    {
      key: "REVERSED",
      title: t("options.transStatus.reversed"),
      value: "REVERSED",
    },
    {
      key: "TIMEOUT",
      title: t("options.transStatus.timeout"),
      value: "TIMEOUT",
    },
    {
      key: "NONE",
      title: t("options.transStatus.none"),
      value: "NONE",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default onlineTransactionStatusOptions;
